// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__xLwXI","line":"divider_line__0TIF3","text":"divider_text__p_bWo"};